<template>
  <v-container v-if="examGroups !== null">
    <v-card>
      <v-tabs class="pro-tabs" v-model="tabid">
        <v-tab v-for="department in departments" :key="department.id">{{ department.name }}</v-tab>
      </v-tabs>

      <v-window v-model="tabid" v-if="examGroups.length">
        <v-window-item v-for="department in departments" :key="department.id">
          <template v-for="(item, i) in examGroups">
            <template v-if="item.department_id == department.id">
              <v-card-item :key="i">
                <v-card-title class="text-wrap">
                  Конкурс {{ item.code }} {{ item.name }} ({{
                    item.education_name
                  }},{{ item.study_name }}
                  <span v-if="item.is_prof == '1'">,профессионалитет</span><span
                    v-if="item.in_group == '1'">,пополнение</span>)
                </v-card-title>
              </v-card-item>

              <v-card-text :key="i">
                <p v-for="exam in item.additionalTest" :key="exam.id">
                  <router-link :to="'/admission/additionalTest/' + exam.id">
                    {{ exam.name }}
                    <span v-if="exam.is_budget == '1'">(бюджет)</span>
                    <span v-else>(договор)</span>
                  </router-link>
                </p>
              </v-card-text>
            </template>
          </template>
        </v-window-item>
      </v-window>
      <div v-else>нет групп для отображения</div>
    </v-card>
  </v-container>
  <template v-else>
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </template>
</template>

<script>
export default {
  name: "additionalTestList",
  data() {
    return {
      examGroups: null,
      departments: [],
      tabid: null,
    };
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot +
        "/procollege/manage_groups/admission/additionalTest/AdditionalTestGetList"
      )
      .then((response) => {
        this.examGroups = response.data.groups;
        this.departments = response.data.departments;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {},
};
</script>
<style lang="scss">
/**
табы мултилайн+перенос строк
 */
.v-slide-group__content {
  flex-wrap: wrap;
  flex: 1 1 auto !important;
}

button.v-tab.v-btn {
  display: flex;
  flex: 1 1 0;

  span.v-btn__content {
    white-space: normal;
    text-align: left;
  }
}

div.v-window.v-tabs-window {
  flex-basis: 100%;
}
</style>
